import React from "react";
import { styled } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  IconButton,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import BlockIcon from "@mui/icons-material/Block";
import { disableMakerPlanModule } from "../../../services/adminServices/MakerPlanServices";
import { toast } from "react-toastify";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#7e7e7e",
    color: theme.palette.common.white,
    textTransform: "capitalize",
    fontSize: 16,
    fontWeight: 600
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    textTransform: "capitalize",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd),&:nth-of-type(even)": {
    backgroundColor: theme.palette.action.hover,
    borderBottom: "1px solid rgba(224, 224, 224, 1)",
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const PracticeModuleTable = ({ rows, onEdit, fetchData, selectedPlan }) => {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(50);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const paginatedRows = rows.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );
  const onDisable = async (moduleData) => {

    try {
      const response = await disableMakerPlanModule(
        moduleData.Maker_Plan_Module.id,
        moduleData.Maker_Plan_Module.makerplanID,
        moduleData.moduleID
      );
      fetchData(selectedPlan);
      toast.success(response?.data.message);
    } catch (error) {
      toast.error(error?.response?.data.message || error?.message || error?.error);
    }
  };


  return (
    <TableContainer component={Paper} className="table-container" sx={{ width: "100%", overflowX: "auto" }}>
      <Table sx={{ tableLayout: "auto", width: "max-content", minWidth:"100%" }} aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell>Practice Module</StyledTableCell>
            <StyledTableCell>Coding Hours</StyledTableCell>
            <StyledTableCell>Type</StyledTableCell>
            <StyledTableCell>Actions</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {paginatedRows
            .filter((row) => row.Maker_Plan_Module?.is_Active)
            .map((row, index) => (
              <StyledTableRow key={index}>
                <StyledTableCell>{row.module_Name}</StyledTableCell>
                <StyledTableCell>{row?.Maker_Plan_Module.module_coding_Hrs}</StyledTableCell>
                <StyledTableCell>{row?.Maker_Plan_Module.coding_type}</StyledTableCell>
                <StyledTableCell>
                  <IconButton
                    size="small"
                    aria-label="edit"
                    onClick={() => onEdit(row)}
                  >
                    <EditIcon fontSize="small" />
                  </IconButton>
                  <IconButton
                    size="small"
                    aria-label="disable"
                    onClick={() => onDisable(row)}
                  >
                    <BlockIcon fontSize="small" />
                  </IconButton>
                </StyledTableCell>
              </StyledTableRow>
            ))}
        </TableBody>

      </Table>
      <TablePagination
        rowsPerPageOptions={[10,20,30,60,100]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </TableContainer>
  );
};

export default PracticeModuleTable;
